import { signal } from '@angular/core';
import { TwcLegendParams } from '../../../twc-legend/twc-legend.params';
import { TwcLegendComponent } from '../../../twc-legend/twc-legend.component';
import { GlobalIRSatelliteRadarSvgComponent } from './global-ir-satellite-radar-svg/global-ir-satellite-radar-legend-svg';

export const GLOBAL_IR_SATELLITE_RADAR_LEGEND: TwcLegendParams = {
  title: 'GLOBAL IR SATELLITE + RADAR',
  legendTitleBarInfo: signal('0'),
  data: { svgComponent: GlobalIRSatelliteRadarSvgComponent },
  legendComponent: TwcLegendComponent
};
